// src/constants/terminalConstants.js

export const FARE_TYPES = {
  KNOWN_FARE: [
    // "DEBT_RECOVERY_MERCHANT_INITIATED",
    // "DEBT_RECOVERY_PAYER_INITIATED",
    // "DEBT_RECOVERY_TAP_INITIATED",
    "FARE_DEFERRED_AUTHORIZATION",
    "FARE_REAL_TIME_AUTHORIZATION",
    "HARDPOS",
    "SOFTPOS",
    "ATM",
  ],

  TRANSPORT_MODE: [
    "CABLE_CAR",
    "COACH",
    "COMMUTER_TRAIN",
    "EXPRESS_COMMUTER_TRAIN",
    "FUNICULAR_TRAIN",
    "HIGH_SPEED_TRAIN",
    "INTERURBAN_BUS",
    "INTER_CITY",
    "LIGHT_TRAIN_MASS_TRANSIT",
    "LOCOMOTIVE",
    "OTHER",
    "PARA_TRANSIT",
    "PARKING",
    "POWERED_MOTOR_VEHICLE",
    "REGIONAL_TRAIN",
    "RURAL_BUS",
    "SELF_DRIVE_VEHICLE",
    "TAXI",
    "TOLL",
    "TRAILER",
    "TRAIN",
    "URBAN_BUS",
    "WATER_BORNE_VEHICLE",
  ],
};

export const POSTERMINAL = {
  ATTENDED: [
    "ATTENDED",
    "SEMI_ATTENDED",
    "UNATTENDED",
    "UNKNOWN_OR_UNSPECIFIED",
  ],

  CARDHOLDER_ACTIVATED: [
    "AUTOMATED_DISPENSING_MACHINE_WITH_PIN",
    "ELECTRONIC_COMMERCE",
    "IN_FLIGHT_COMMERCE",
    "LIMITED_AMOUNT_TERMINAL",
    "MPOS_ACCEPTANCE_DEVICE",
    "NOT_CARDHOLDER_ACTIVATED",
    "SELF_SERVICE_TERMINAL",
    "TRANSPONDER_TRANSACTION",
  ],

  CARD_PRESENCE_CAPABILITY: [
    "CARD_NOT_PRESENT",
    "CARD_PRESENT",
    "CARD_PRESENT_AND_CARD_NOT_PRESENT",
  ],

  INPUT_CAPABILITY: [
    "BARCODE",
    "CHIP",
    "CHIP_AND_KEY_ENTRY_AND_MAGNETIC_STRIPE",
    "CHIP_AND_KEY_ENTRY_AND_MAGNETIC_STRIPE_AND_RFID",
    "CHIP_AND_MAGNETIC_STRIPE",
    "CONTACTLESS_CHIP",
    "CONTACTLESS_MAGNETIC_STRIPE",
    "CONTACTLESS_OR_MAGNETIC_STRIPE",
    "KEY_ENTRY",
    "KEY_ENTRY_AND_MAGNETIC_STRIPE",
    "MAGNETIC_STRIPE",
    "UNKNOWN",
    "VOICE_AUDIO_RESPONSE",
  ],

  LOCATION: [
    "MERCHANT_TERMINAL_OFF_PREMISES",
    "MERCHANT_TERMINAL_ON_PREMISES",
    "NO_TERMINAL_VOICE_OR_AUDIO_RESPONSE",
    "PAYER_TERMINAL_OFF_PREMISES",
    "PAYER_TERMINAL_ON_PREMISES",
  ],

  ONLINE_REASON_CODE: [
    "CHIP_APPLICATION_DATA_FILE_ERROR",
    "CHIP_COMMON_DATA_FILE_ERROR",
    "FORCED_BY_CHIP",
    "FORCED_BY_ISSUER",
    "FORCED_BY_MERCHANT",
    "FORCED_BY_TERMINAL",
    "MERCHANT_SUSPICIOUS",
    "OVER_FLOOR_LIMIT",
    "RANDOM_SELECTION_BY_TERMINAL",
    "UNABLE_TO_PROCESS_CHIP",
  ],

  PAN_ENTRY_MODE: [
    "BARCODE_READER",
    "CHIP",
    "CHIP_FALLBACK",
    "CONTACTLESS",
    "ECOMMERCE",
    "KEYED",
    "MOBILE_COMMERCE",
    "OPTICAL_CHARACTER_READER",
    "RFID_CHIP",
    "RFID_STRIPE",
    "SWIPE",
    "SWIPE_WITH_SIGNATURE",
    "UNKNOWN",
    "VOICE_AUTHORIZATION",
    "VOICE_RESPONSE",
  ],

  PIN_ENTRY_CAPABILITY: [
    "OFFLINE_PIN_ONLY",
    "PIN_NOT_SUPPORTED",
    "PIN_PAD_INOPERATIVE",
    "PIN_SUPPORTED",
    "SOFTWARE_ONLINE_PIN_ONLY",
    "UNKNOWN",
  ],
  TRANSACTION_TYPE: [
    { label: "Sales", value: "SALES" },
    { label: "Void", value: "VOID" },
    { label: "Refund", value: "REFUND" },
    { label: "Settlement", value: "SETTLEMENT" },
    { label: "Pre Auth", value: "PRE AUTH" },
    { label: "Pre Auth Completion", value: "PRE AUTH COMPLETION" },
    { label: "Tip", value: "TIP" },
    { label: "Tip Completion", value: "TIP COMPLETION" },
    { label: "Sales Adjust", value: "SALES ADJUST" },
    { label: "Balance Inquiry", value: "BALANCE INQUIRY" },
    { label: "QR Payments", value: "QR PAYMENTS" },
    { label: "Kisan Card", value: "KISAN CARD" },
   
   
  ],
};
